export default "__VITE_ASSET__D3tY2m6K__"